// extracted by mini-css-extract-plugin
export var brand = "_4r-9";
export var compact = "_4r-6";
export var extraSmall = "_4r-7";
export var icon = "_4r-0";
export var large = "_4r-4";
export var light = "_4r-1";
export var medium = "_4r-5";
export var outline = "_4r-b";
export var primaryDark = "_4r-a";
export var primaryLight = "_4r-8";
export var primaryModern = "_4r-c";
export var success = "_4r-2";
export var successSolid = "_4r-3";